module.exports = __webpack_public_path__ + "img/img-5-mobile.04479b67.png";